import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import ClientConfig from '@/clients/entities/client-config'
import PushMessage from '@/clients/entities/push-message'

class PushService {
  public async sendAsync(config: ClientConfig, message: PushMessage) {
    const res = await axios.post<any>(`push/${config.clientId}`, message)
    return Responses.obj(res)
  }
}

export default new PushService()
